import './Experience.css';
import {GoVerified} from 'react-icons/go'
const Experience=()=>{
    return(
        <>
            <section id='experience'>
            <h5>What Skills I Have</h5>
            <h2>My Experience</h2>
            <div className='container container_exp'>
                <div className='container_exp_content'>
                    <h3>Frontend Development </h3>
                    <div className='exp_content1'>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>HTML</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>Javascript</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>React JS</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>CSS</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>Bootstrap</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='container_exp_content'>
                    <h3>Backend Development</h3>
                    <div className='exp_content1'>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>Node JS</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>MySql</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>MongoDB</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>Javascript</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                        <div className='exp_content11'>
                            <div className='exp_content111'><GoVerified/></div>
                            <div>
                            <h3>Express JS</h3>
                            <p>Experienced</p>
                            </div>
                        </div>
                </div>
            </div>
        </div>
            </section>
        </>
        );
}
export default Experience;